import { css } from '@emotion/css';

const wrapper = css`
  height: 100%;
  border: 1px solid var(--colors-primary-900);
  display: flex;
  padding: 2rem 1.25rem;
  margin-bottom: 0.75rem;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: var(--colors-white);
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-duration: 200ms;
  color: #00143a;

  &:hover {
    color: var(--colors-white);
    background: var(--colors-primary-900);
  }
`;

const content = css`
  display: flex;
  align-items: center;
`;

const iconWrapper = css`
  display: flex;
  margin-right: 0.75rem;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  width: 4rem;
  height: 4rem;
  background: var(--colors-primary-200);
`;

const icon = css`
  &.MuiSvgIcon-root {
    width: 2.25rem;
    height: 2.25rem;
    color: var(--colors-primary-500);
  }
`;

const textWrapper = css`
  text-align: left;
`;

const contentTitle = css`
  &.MuiTypography-root {
    display: inline-block;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border-radius: 0.75rem;
    font-size: 0.75rem;
    line-height: 1rem;
    color: #ffffff;
    background: #016bf8;
  }
`;

const contentMessage = css`
  &.MuiTypography-root {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-weight: 600;
    color: inherit;
    font-family: Inter;
  }
`;

const PaymentLinkButtonStyles = {
  wrapper,
  content,
  iconWrapper,
  icon,
  textWrapper,
  contentTitle,
  contentMessage,
};

export default PaymentLinkButtonStyles;
